/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ExportInputs */

const en_us2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export my data`)
};

const pt_br2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar meus dados`)
};

const es_419_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar mis datos`)
};

const pt_pt2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar os meus dados`)
};

const fr_fr2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter mes données`)
};

const de_de2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Daten exportieren`)
};

const it_it2_search_field_export = /** @type {(inputs: Search_Field_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta i miei dati`)
};

/**
* | output |
* | --- |
* | "Export my data" |
*
* @param {Search_Field_ExportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_export = /** @type {((inputs?: Search_Field_ExportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ExportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_export(inputs)
	if (locale === "es-419") return es_419_search_field_export(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_export(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_export(inputs)
	if (locale === "de-DE") return de_de2_search_field_export(inputs)
	if (locale === "it-IT") return it_it2_search_field_export(inputs)
	return en_us2_search_field_export(inputs)
});
export { search_field_export as "search.field_export" }